import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import {
  PRODUCTS_REQUEST_LIST,
  PRODUCTS_ROW_REQUEST,
  MY_MATERIALREQUEST_LIST,
  MATERIALREQUEST_LIST,
  DEPT_MATERIALREQUEST_LIST,
  ALL_MATERIALREQUEST_LIST,
  MATERIALREQUEST_LIST_COUNT,
  MY_MATERIALREQUEST_LIST_COUNT,
  DEPT_MATERIALREQUEST_LIST_COUNT,
  ALL_MATERIALREQUEST_LIST_COUNT,
  ITEM_HOD_APPROVAL,
  MR_ITEM_HOD_APPROVAL,
  MRI_STORE_USER_APPROVAL,
  MRI_STORE_HOD_APPROVAL,
  MR_DEPT_HOD_APPROVE_ADD,
  MR_HOD_APPROVE_ADD,
  MATERIALREQUEST_ADD,
  GET_USER_DEPARTMENT,
  MATERIALREQUEST_ROW_DATA,
  MODEL_LIST_OPEN,
  MATERIALREQUEST_DELETE,
  CUSTOM_PRODUCT_ADD,
  C_PRODUCT_RIGHT_SIDEBAR,
  C_PRODUCT_HIDE_RIGHT_SIDEBAR,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  VIEW_LOG_SHOW_RIGHT_SIDEBAR,
  VIEW_LOG_HIDE_RIGHT_SIDEBAR,
  ITEM_TIME_LINE,
  PRODUCT_STORE_QTY,
  PDF_DOWNNLOAD,
  PRODUCT_HISTORY,
  MR_ITEM_UPDATE_IMAGE,
  MATERIAL_REQUEST_CLOSE,
  MRQ_FOCUS_POST,
} from "./actionTypes";

import {
  apiError,
  toggleTab,
  getMyMeterialReqList,
  productsRequestListSuccessful,
  productRowSuccessful,
  materialRequestListSuccessful,
  MRListCountSuccessful,
  getReqestRowDetails,
  UserDepartmentSuccessfull,
  materialRequestRowloading,
  CostomproductAddSuccessful,
  MaterialRequestAddSuccessful,
  materialRequestsuccessfull,
  GetItemTimeLineSuccessful,
  GetItemTimeLine,
  getProductStoreQty,
  getProductStoreQtySuccessful,
  ProductHistorySuccessful,
  getMeterialReqList,
  SetParams,
  getAllMeterialReqList,
} from "./actions";
import { getMRList } from "../PurchaseIndent/actions";

import {
  postAdd,
  putImg,
  getList,
  getParamsList,
  postEdit,
  postDelete,
  getDownloadFile,
  postFormData,
} from "../../helpers/Helper";
import swal from "sweetalert";

function* getProductRequestList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
      } else {
        if (data[k] !== "") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/masters/mini/products/",
      params,
    );
    // console.log(response, ")))))))))))))))))))))))))");
    yield put(productsRequestListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getProductRow({ payload }) {
  try {
    const response = yield call(getList, "/masters/products/" + payload.id, {});
    yield put(productRowSuccessful({ response }));
    yield put(getProductStoreQty(payload.id));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* matrialRequestAdd({
  payload: { material, materialId, history, callBack },
}) {
  yield put(materialRequestRowloading(true));

  try {
    if (materialId === "0") {
      const response = yield call(postAdd, "/materialrequest/", material);

      if (response.status === 201) {
        swal("Your Request Added Successfully.!", {
          icon: "success",
        });
        callBack(true, response.data);
        yield put(materialRequestRowloading(false));
        history.push("/mrdashboard1");
        yield put(MaterialRequestAddSuccessful(null));
      } else {
        swal("Sorry! Unable to add Request. Please Try Again!", {
          icon: "error",
        });
      }
    } else {
      const response = yield call(
        postEdit,
        "/materialrequest/" + materialId,
        material,
      );
      if (response.status === 200) {
        swal("Your Request Edited Successfully.!", {
          icon: "success",
        });
        callBack(true, response.data);
        yield put(materialRequestRowloading(false));
        history.push("/mrdashboard1");
        yield put(MaterialRequestAddSuccessful(null));
      } else {
        swal("Sorry! Unable to edit Request. Please Try Again!", {
          icon: "error",
        });
      }
    }
  } catch (error) {
    yield put(materialRequestRowloading(false));
    yield put(apiError(error));
    callBack(false, false);
    swal(
      "There was an error in submitting data, please check the input fields and try again.",
      {
        icon: "error",
      },
    );
  }
}
function* MrItemUpdateImage({ payload: { data } }) {
  try {
    const response = yield call(
      postFormData,
      "/materialrequest/mritemimage",
      data,
    );
    // yield put(productRowSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getMyMaterialRequestsListCount() {
  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/count/myrequests",
      {},
    );

    yield put(MRListCountSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getDeptMaterialRequestsListCount() {
  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/count/mydeprequests",
      {},
    );

    yield put(MRListCountSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getMaterialRequestsListCount({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
      } else if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }

  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/count/list",
      params,
    );

    yield put(MRListCountSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getAllMaterialRequestsListCount() {
  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/count/alllist",
      {},
    );

    yield put(MRListCountSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getMyMaterialRequestsList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus" || k === "pistatus" || k === "mistatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
        if (data.pistatus[0] !== 0) {
          params.pistatus = data.pistatus.join(",");
        }
        if (data.mistatus[0] !== 0) {
          params.mistatus = data.mistatus.join(",");
        }
      } else if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }

  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/myrequests",
      params,
    );

    yield put(materialRequestListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getMaterialRequestsList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus" || k === "pistatus" || k === "mistatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
        if (data.pistatus[0] !== 0) {
          params.pistatus = data.pistatus.join(",");
        }
        if (data.mistatus[0] !== 0) {
          params.mistatus = data.mistatus.join(",");
        }
      } else if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/materialrequest/list", params);
    yield put(materialRequestListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getDetpMaterialRequestsList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus" || k === "pistatus" || k === "mistatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
        if (data.pistatus[0] !== 0) {
          params.pistatus = data.pistatus.join(",");
        }
        if (data.mistatus[0] !== 0) {
          params.mistatus = data.mistatus.join(",");
        }
      } else if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }

  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/mydeprequests",
      params,
    );

    yield put(materialRequestListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* getAllMaterialRequestsList({ payload: { data } }) {
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "mrstatus" || k === "pistatus" || k === "mistatus") {
        if (data.mrstatus[0] !== 0) {
          params.mrstatus = data.mrstatus.join(",");
        }
        if (data.pistatus[0] !== 0) {
          params.pistatus = data.pistatus.join(",");
        }
        if (data.mistatus[0] !== 0) {
          params.mistatus = data.mistatus.join(",");
        }
      } else if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "" && k !== "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }

  try {
    const response = yield call(
      getParamsList,
      "/materialrequest/alllist",
      params,
    );

    yield put(materialRequestListSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* userdepartment({ payload: { id } }) {
  try {
    const response = yield call(getList, "/masters/mini/user/departments/", {});
    yield put(UserDepartmentSuccessfull(response));
    yield put(getReqestRowDetails(id));
  } catch (error) {
    swal(error, {
      icon: "error",
    });
  }
}
function* MaterialRequestRowData({ payload }) {
  try {
    const response = yield call(getList, "/materialrequest/" + payload.id);
    yield put(
      materialRequestsuccessfull({
        response: {
          ...response,
          locationLabel: response.location ? response.location.name : "",
          location_id: response.location ? response.location.id : 0,

          sublocationLabel: response.sublocation
            ? response.sublocation.name
            : "",
          sublocation_id: response.sublocation ? response.sublocation.id : 0,

          orderlocationLabel: response.orderlocation
            ? response.orderlocation.name
            : "",
          orderlocation_id: response.orderlocation
            ? response.orderlocation.id
            : 0,

          userdepartment_id: response.userdepartment
            ? response.userdepartment.id
            : 0,
          userdepartmentLabel: response.userdepartment
            ? response.userdepartment.name
            : "",
          department_ids: response.departments,
        },
      }),
    );
    if (payload.timeLine && response.mritems.length > 0) {
      yield put(GetItemTimeLine(response.mritems[0].id));
    }
  } catch (error) {
    yield put(apiError(error));
    swal(error, {
      icon: "error",
    });
  }
}
function* DeleteMaterialRequest({ payload: { id } }) {
  try {
    const response = yield call(postDelete, "/materialrequest/" + id);
    if (response.status === 204) {
      swal("Your Material Request has been deleted!", {
        icon: "success",
      });
      yield put(
        getMyMeterialReqList({
          mrstatus: [0],
          search: "",
          start_date: "",
          end_date: "",
          userdepartment: "",
          department: "",
        }),
      );
    } else {
      swal("Sorry! Your Material Request has been not deleted!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}
function* hodItemApproval({ payload: { data } }) {
  try {
    const response = yield call(
      postAdd,
      "/materialrequest/mydepmriapprove",
      data,
    );

    // console.log(
    // 	data,
    // 	"data---materialrequest/mydepmriapprove itemn wise request"
    // );

    if (response.status === 201) {
      if (data.mrstatus === 3)
        swal(" Your Material Request Item has been approved sucessfully!", {
          icon: "success",
        });
      else if (data.mrstatus === 4) {
        swal(" Your Material Request Item has been Rejected sucessfully!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));
      yield put(getReqestRowDetails(data.materialrequest_id));
    } else {
      if (data.mrstatus === 3)
        swal(" Sorry! Your Material Request Item has been not approved!", {
          icon: "success",
        });
      else if (data.mrstatus === 4) {
        swal(" Sorry! Your Material Request Item has been not Rejected!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));
    }
    // yield put(materialRequestsuccessfull(null));
  } catch (error) {
    yield put(materialRequestRowloading(false));
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}
function* MRHodItemApproval({ payload: { data } }) {
  try {
    const response = yield call(postAdd, "/materialrequest/mriapprove", data);

    console.log(
      data,
      "data---materialrequest/mriapprove chnage the product while editing",
    );
    // console.log(response, "response-----------------");
    if (response.status === 201) {
      if (data.mrstatus === 5)
        swal(" Your Material Request Item has been approved sucessfully!", {
          icon: "success",
        });
      else if (data.mrstatus === 6) {
        swal(" Your Material Request Item has been Rejected sucessfully!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));

      yield put(getReqestRowDetails(data.materialrequest_id));
    } else {
      if (data.mrstatus === 5)
        swal(" Sorry! Your Material Request Item has been not approved!", {
          icon: "success",
        });
      else if (data.mrstatus === 6) {
        swal(" Sorry! Your Material Request Item has been not Rejected!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));
    }
  } catch (error) {
    yield put(materialRequestRowloading(false));
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}
function* MRISUserApproval({ payload: { data } }) {
  try {
    const response = yield call(
      postAdd,
      "/materialrequest/storeusermriapprove",
      data,
    );

    if (response.status === 201) {
      if (data.mrstatus === 13) {
        swal(" Your Material Request Item has been Cancle sucessfully!", {
          icon: "success",
        });
      } else {
        swal(" Your Material Request Item has been changed sucessfully!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));

      // history.push("/newpirequest/0");
      yield put(
        getMRList({
          // ...this.props.params,
          // MrId: this.props.openMRid,
          // Index: this.props.openMRindex,
          // search: e.target.value,
          page: 1,
        }),
      );
    } else {
      swal(" Sorry! Your Material Request Item has been not changed!", {
        icon: "success",
      });

      yield put(materialRequestRowloading(false));
    }
  } catch (error) {
    yield put(materialRequestRowloading(false));
    swal("Sorry! Error in getting from the Server", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

function* MRISHodApproval({ payload: { data } }) {
  //PIData
  // var piItemdata = {
  //   pistatus: 9,
  //   purchaseindent_id: PIData.purchaseindent_id,
  //   piitem_id: PIData.piitem_id,
  //   piimris: PIData.piimris,
  //   t_product_id: data.t_product_id,
  //   t_qty: data.t_qty,
  //   t_unit: data.t_unit,
  //   t_make: data.t_make,
  //   t_description: data.t_description,
  // };
  try {
    const response = yield call(
      postAdd,
      "/materialrequest/storehodmriapprove",
      data,
    );

    if (response.status === 201) {
      // yield put(PIDepItemapprove(piItemdata));
      // swal(" Your Item has been changed sucessfully!", {
      //   icon: "success",
      // });

      yield put(materialRequestRowloading(false));
    } else {
      swal(" Sorry! Your Item has been not changed!", {
        icon: "success",
      });

      yield put(materialRequestRowloading(false));
    }
  } catch (error) {
    yield put(materialRequestRowloading(false));
    swal("Sorry! Error in getting from the Server", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}
function* matrialDeptHodApproveRequestAdd({ payload: { material, history } }) {
  yield put(materialRequestRowloading(true));
  try {
    const response = yield call(
      postAdd,
      "/materialrequest/mydepmrapprove",
      material,
    );
    // console.log(material, "material---ghgykjhujk,ujiiktyyg");
    if (response.status === 201) {
      if (material.mrstatus === 3)
        swal(" Your Material Request has been approved sucessfully!", {
          icon: "success",
        });
      else if (material.mrstatus === 4) {
        swal(" Your Material Request has been Rejected sucessfully!", {
          icon: "success",
        });
      }

      yield put(materialRequestRowloading(false));
      yield put(getReqestRowDetails(material.materialrequest_id));

      // history.push("/mrdashboard2");
    } else {
      if (material.mrstatus === 3)
        swal(" Sorry! Your Material Request has been not approved!", {
          icon: "success",
        });
      else if (material.mrstatus === 4) {
        swal(" Sorry! Your Material Request has been not Rejected!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));
    }
    yield put(MaterialRequestAddSuccessful(null));
  } catch (error) {
    yield put(materialRequestRowloading(false));
    swal(error, {
      icon: "error",
    });
  }
}
function* matrialHodApproveRequestAdd({ payload: { material, history } }) {
  yield put(materialRequestRowloading(true));
  try {
    const response = yield call(
      postAdd,
      "/materialrequest/mrapprove",
      material,
    );
    // console.log(
    // 	material,
    // 	"material---ghgykjhujk,ujiiktyyg materil apptoval screen "
    // );
    if (response.status === 201) {
      if (material.mrstatus === 5)
        swal(" Your Material Request has been approved sucessfully!", {
          icon: "success",
        });
      else if (material.mrstatus === 6) {
        swal(" Your Material Request has been Rejected sucessfully!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));
      yield put(getReqestRowDetails(material.materialrequest_id));

      history.push("/mrdashboard");
    } else {
      if (material.mrstatus === 3)
        swal(" Sorry! Your Material Request has been not approved!", {
          icon: "success",
        });
      else if (material.mrstatus === 4) {
        swal(" Sorry! Your Material Request has been not Rejected!", {
          icon: "success",
        });
      }
      yield put(materialRequestRowloading(false));
    }
    yield put(MaterialRequestAddSuccessful(null));
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });
    yield put(apiError(error));
    yield put(materialRequestRowloading(false));
  }
}

function* AddCustomProduct({ payload: { data } }) {
  try {
    const response = yield call(
      postAdd,
      "/masters/custproducts/",
      data.CustomProductData,
    );
    if (response.status === 201) {
      if (data.cPimage.name) {
        const response2 = yield call(
          putImg,
          "/masters/custproducts/" + response.data.id,
          {
            file: data.cPimage,
            name: "image",
          },
        );
        if (response2.status === 200) {
          swal("Your Product Added Successfully.!", {
            icon: "success",
            timer: 1500,
          });
          yield put(CostomproductAddSuccessful(response2));
        } else {
          swal("Sorry! Unable to add Product Image. Please Try Again!", {
            icon: "error",
            timer: 1500,
          });
        }
      } else {
        swal("Your Product Added Successfully.!", {
          icon: "success",
          timer: 1500,
        });

        yield put(CostomproductAddSuccessful(response));
      }
      data.FromReset();
      yield put(toggleTab(1));
    } else {
      swal("Sorry! Unable to add Product. Please Try Again!", {
        icon: "error",
      });
    }
  } catch (errors) {
    yield put(apiError(errors));
  }
}
function* itemTimeLine({ payload: { MRItemId } }) {
  try {
    const response = yield call(
      getList,
      "/reports/mritemtimeline/" + MRItemId,
      {},
    );
    yield put(GetItemTimeLineSuccessful(response));
  } catch (error) {
    swal(error, {
      icon: "error",
    });
  }
}
function* productStoreQty({ payload: { ProductID } }) {
  try {
    const response = yield call(
      getList,
      "/focus/stock/" + ProductID, //USE THIS FOR FOCUS INTEGRATION
      // "/masters/user/inventory/product/" + ProductID,//USE THIS FOR WITH OUT FOCUS INTEGRATION
      {},
    );
    yield put(getProductStoreQtySuccessful(response));
  } catch (error) {
    swal("Error in getting Stock data from the Server", {
      icon: "error",
    });
  }
}
function* productHistory({ payload: { ProductID } }) {
  // ProductID = 10225;
  try {
    const response = yield call(
      getList,
      "/materialissue/history/" + ProductID,

      {},
    );
    yield put(ProductHistorySuccessful(response));
  } catch (error) {
    swal("Error in getting Stock data from the Server", {
      icon: "error",
    });
  }
}
function* generatePDF({ payload: { MRId } }) {
  try {
    yield call(getDownloadFile, "/materialrequest/pdf/" + MRId);

    // generateRFQasPDF("RFQ",response)
  } catch (error) {
    yield put(apiError(error));
  }
}
//** C-ProductRightSidebar */
/**
 * CProduct the class on body
 * @param {*} cssClass
 */
function manageBodyClass(cssClass, action = "toggle") {
  switch (action) {
    case "add":
      if (document.body) document.body.classList.add(cssClass);
      break;
    case "remove":
      if (document.body) document.body.classList.remove(cssClass);
      break;
    default:
      if (document.body) document.body.classList.toggle(cssClass);
      break;
  }

  return true;
}

function* cProductRightSidebar() {
  try {
    yield call(manageBodyClass, "cp-right-bar-enabled");
  } catch (error) {}
}
function* cProducthideRightSidebar() {
  try {
    yield call(manageBodyClass, "cp-right-bar-enabled", "remove");
  } catch (error) {}
}
function* FilterShowRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled");
  } catch (error) {}
}
function* FilterHideRightSidebar() {
  try {
    yield call(manageBodyClass, "filters-right-bar-enabled", "remove");
  } catch (error) {}
}
function* ViewLogShowRightSidebar({ payload: { MRId } }) {
  try {
    yield call(manageBodyClass, "timeLine-right-bar-enabled");
    yield put(getReqestRowDetails(MRId, true));
  } catch (error) {}
}
function* ViewLogHideRightSidebar() {
  try {
    yield call(manageBodyClass, "timeLine-right-bar-enabled", "remove");
  } catch (error) {}
}

// Material Request Close

function* CloseMaterialRequest({ payload: { id } }) {
  try {
    const response = yield call(postAdd, "/materialrequest/mrclose/" + id);
    if (response.status === 200) {
      swal("Your Material Request has been closed!", {
        icon: "success",
      });
      yield put(
        getMeterialReqList({
          mrstatus: [0],
          pistatus: [0],
          mistatus: [0],
          search: "",
          start_date: "",
          end_date: "",
          userdepartment: "",
          department: "",
        }),
      );
      // yield put(SetParams({
      //   mrstatus: [0],
      //   pistatus: [0],
      //   mistatus: [0],
      //   search: "",
      //   start_date: "",
      //   end_date: "",
      //   userdepartment: "",
      //   departments: "",
      // }))
    } else {
      swal("Sorry! Your Material Request has been not closed!", {
        icon: "error",
      });
    }
  } catch (error) {
    swal("Sorry! Permission Denied!", {
      icon: "error",
    });

    yield put(apiError(error));
  }
}

// MRQ Focus post api

function* PostFocusMrq({ payload: { id, data } }) {
  try {
    const response = yield call(
      postAdd,
      "/thirdparty/fsyncmaterialrequest/" + id.id,
    );
    // console.log("response", response);
    if (response.status === 200) {
      if (response.data.result == true) {
        // swal("Your Material Request is successfully synchronised into focus", {
        //   icon: "success",
        // });
        swal({
          title: response.data.msg,
          icon: "error",
        });
      } else {
        swal({
          title: response.data.msg,
          icon: "error",
        });
      }
      yield put(getReqestRowDetails(id.data));
    } else {
      swal(
        "Sorry! selected  Material Request is not posted on focus. please try again!",
        {
          icon: "error",
        },
      );
    }
  } catch (error) {
    // console.log("object", error);
    swal("Sorry! Permission Denied! +++++++++++++", {
      icon: "error",
    });
    yield put(apiError(error));
  }
}

/*** C-ProductRightSidebar End** */

export function* watchgetProductRequestList() {
  yield takeEvery(PRODUCTS_REQUEST_LIST, getProductRequestList);
}
export function* watchgetRowProductRequest() {
  yield takeEvery(PRODUCTS_ROW_REQUEST, getProductRow);
}
export function* watchMaterialRequestAdd() {
  yield takeEvery(MATERIALREQUEST_ADD, matrialRequestAdd);
}
export function* watchgetMyMaterialRequestCount() {
  yield takeEvery(
    MY_MATERIALREQUEST_LIST_COUNT,
    getMyMaterialRequestsListCount,
  );
}
export function* watchgetDeptMaterialRequestCount() {
  yield takeEvery(
    DEPT_MATERIALREQUEST_LIST_COUNT,
    getDeptMaterialRequestsListCount,
  );
}
export function* watchgetAllMaterialRequestCount() {
  yield takeEvery(
    ALL_MATERIALREQUEST_LIST_COUNT,
    getAllMaterialRequestsListCount,
  );
}
export function* watchgetMaterialRequestCount() {
  yield takeEvery(MATERIALREQUEST_LIST_COUNT, getMaterialRequestsListCount);
}
export function* watchgetMyMaterialRequestList() {
  yield takeEvery(MY_MATERIALREQUEST_LIST, getMyMaterialRequestsList);
}
export function* watchgetMaterialRequestList() {
  yield takeEvery(MATERIALREQUEST_LIST, getMaterialRequestsList);
}
export function* watchgetDetpMaterialRequestList() {
  yield takeEvery(DEPT_MATERIALREQUEST_LIST, getDetpMaterialRequestsList);
}
export function* watchgetAllMaterialRequestList() {
  yield takeEvery(ALL_MATERIALREQUEST_LIST, getAllMaterialRequestsList);
}
export function* watchGetUserDepartments() {
  yield takeEvery(GET_USER_DEPARTMENT, userdepartment);
}
export function* watchMaterialRequestRowData() {
  yield takeEvery(MATERIALREQUEST_ROW_DATA, MaterialRequestRowData);
}
export function* watchMaterialRequestlistItem() {
  yield takeEvery(MODEL_LIST_OPEN, MaterialRequestRowData);
}
export function* watchMaterialRequestDelete() {
  yield takeEvery(MATERIALREQUEST_DELETE, DeleteMaterialRequest);
}
export function* watchItemHodApproval() {
  yield takeEvery(ITEM_HOD_APPROVAL, hodItemApproval);
}
export function* watchIMRtemHodApproval() {
  yield takeEvery(MR_ITEM_HOD_APPROVAL, MRHodItemApproval);
}
export function* watchMRISUserApproval() {
  yield takeEvery(MRI_STORE_USER_APPROVAL, MRISUserApproval);
}
export function* watchMRISHodApproval() {
  yield takeEvery(MRI_STORE_HOD_APPROVAL, MRISHodApproval);
}
export function* watchMRDeptHodApproveRequestAdd() {
  yield takeEvery(MR_DEPT_HOD_APPROVE_ADD, matrialDeptHodApproveRequestAdd);
}
export function* watchMRHodApproveRequestAdd() {
  yield takeEvery(MR_HOD_APPROVE_ADD, matrialHodApproveRequestAdd);
}
export function* watchCustomProductAdd() {
  yield takeEvery(CUSTOM_PRODUCT_ADD, AddCustomProduct);
}
export function* watchCPRightSidebar() {
  yield takeEvery(C_PRODUCT_RIGHT_SIDEBAR, cProductRightSidebar);
}
export function* watchCPHideRightSidebar() {
  yield takeEvery(C_PRODUCT_HIDE_RIGHT_SIDEBAR, cProducthideRightSidebar);
}
export function* watchFilterShowRightSidebar() {
  yield takeEvery(FILTERS_SHOW_RIGHT_SIDEBAR, FilterShowRightSidebar);
}
export function* watchfilterHideRightSidebarr() {
  yield takeEvery(FILTERS_HIDE_RIGHT_SIDEBAR, FilterHideRightSidebar);
}
export function* watchViewLogShowRightSidebar() {
  yield takeEvery(VIEW_LOG_SHOW_RIGHT_SIDEBAR, ViewLogShowRightSidebar);
}
export function* watchViewLogHideRightSidebarr() {
  yield takeEvery(VIEW_LOG_HIDE_RIGHT_SIDEBAR, ViewLogHideRightSidebar);
}
export function* watchItemTimeLine() {
  yield takeEvery(ITEM_TIME_LINE, itemTimeLine);
}
export function* watchProductStoreQty() {
  yield takeEvery(PRODUCT_STORE_QTY, productStoreQty);
}
export function* watchgeneratePDF() {
  yield takeEvery(PDF_DOWNNLOAD, generatePDF);
}
export function* watchProductHistory() {
  yield takeEvery(PRODUCT_HISTORY, productHistory);
}
export function* watchMRItemUpdateImage() {
  yield takeEvery(MR_ITEM_UPDATE_IMAGE, MrItemUpdateImage);
}
export function* watchMaterialRequestClose() {
  yield takeEvery(MATERIAL_REQUEST_CLOSE, CloseMaterialRequest);
}
export function* watchMrqFocusPost() {
  yield takeEvery(MRQ_FOCUS_POST, PostFocusMrq);
}
function* MaterialRequestSaga() {
  yield all([
    fork(watchgetProductRequestList),
    fork(watchgetMyMaterialRequestList),
    fork(watchgetDetpMaterialRequestList),
    fork(watchgetAllMaterialRequestList),
    fork(watchgetRowProductRequest),
    fork(watchgetDeptMaterialRequestCount),
    fork(watchgetAllMaterialRequestCount),
    fork(watchgetMyMaterialRequestCount),
    fork(watchgetMaterialRequestCount),
    fork(watchgetMaterialRequestList),
    fork(watchMaterialRequestAdd),
    fork(watchGetUserDepartments),
    fork(watchMaterialRequestRowData),
    fork(watchMaterialRequestlistItem),
    fork(watchMaterialRequestDelete),
    fork(watchItemHodApproval),
    fork(watchIMRtemHodApproval),
    fork(watchMRISUserApproval),
    fork(watchMRISHodApproval),
    fork(watchMRDeptHodApproveRequestAdd),
    fork(watchMRHodApproveRequestAdd),

    fork(watchCustomProductAdd),
    fork(watchCPRightSidebar),
    fork(watchCPHideRightSidebar),
    fork(watchFilterShowRightSidebar),
    fork(watchfilterHideRightSidebarr),
    fork(watchViewLogShowRightSidebar),
    fork(watchViewLogHideRightSidebarr),
    fork(watchItemTimeLine),
    fork(watchProductStoreQty),
    fork(watchgeneratePDF),
    fork(watchProductHistory),
    fork(watchMRItemUpdateImage),
    fork(watchMaterialRequestClose),
    fork(watchMrqFocusPost),
  ]);
}

export default MaterialRequestSaga;
